module.exports = __webpack_public_path__ + "img/PCataphract64_ua.f9352a59.webp";